// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "call_window_limit_date.proto" (syntax proto3)
// tslint:disable
import { CallWindowLimitDateService } from "./call_window_limit_date";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * Per-date overrides of a call window's limits, the layer below the weekly
 * department override in call_window_limit. Resolution order, lowest to highest
 * precedence: call_window (base) -> call_window_limit (weekly) -> this.
 *
 * @generated from protobuf service CallWindowLimitDateService
 */
export class CallWindowLimitDateServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = CallWindowLimitDateService.typeName;
        this.methods = CallWindowLimitDateService.methods;
        this.options = CallWindowLimitDateService.options;
    }
    /**
     * @generated from protobuf rpc: CreateCallWindowLimitDate
     */
    createCallWindowLimitDate(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCallWindowLimitDate
     */
    getCallWindowLimitDate(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetCallWindowLimitDate
     */
    batchGetCallWindowLimitDate(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCallWindowLimitDate
     */
    updateCallWindowLimitDate(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteCallWindowLimitDate
     */
    deleteCallWindowLimitDate(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Overrides falling in an inclusive date range, optionally narrowed to one
     * department. Serves the scheduler's visible week and the dialog's 60-day
     * upcoming list; BatchGet cannot express a range.
     *
     * @generated from protobuf rpc: BatchGetCallWindowLimitDateRange
     */
    batchGetCallWindowLimitDateRange(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Writes every (window, date) entry in one transaction. The dialog's calendar
     * is multi-select, so a single save spans N dates x M windows.
     *
     * @generated from protobuf rpc: BulkUpsertCallWindowLimitDate
     */
    bulkUpsertCallWindowLimitDate(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Clears every (window, date) entry in one transaction: a row set back to its
     * weekly value, or "Reset these dates to weekly" across the whole selection.
     *
     * @generated from protobuf rpc: BulkDeleteCallWindowLimitDate
     */
    bulkDeleteCallWindowLimitDate(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
